import { classnames } from 'tailwindcss-classnames';
import ArrowCollapse from 'components/helpers/SvgIcon/icons/arrow-collape';
import ArroweExpand from 'components/helpers/SvgIcon/icons/arrow-expand';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { MobileTabsProps, TabProps } from './_types';

export const MobileTabsLayout = ({
  rendering,
  fields,
  toggleCategory,
  isOpenMobile,
}: MobileTabsProps) => {
  const categories = fields?.tabsItems as TabProps[];
  const noCategories = !categories || categories.length === 0;
  const arrowClassNames = classnames(`text-blue-morning`, `w-[20px]`, `h-[10px]`);

  return (
    <>
      {noCategories && <span>Add a tab to get started.</span>}
      <ul data-nmdp-tabstrip="tabstrip" className={classnames({ hidden: noCategories })}>
        {categories.map((item, index) => (
          <li
            key={item.id}
            className={classnames(`border-t`, `border-solid`, `border-gray-midGray`, `py-[24px]`)}
          >
            <div>
              <button
                type="button"
                data-nmdp-tab={index}
                className={classnames(
                  `font-bold`,
                  `flex`,
                  `text-left`,
                  `cursor-pointer`,
                  `w-full`,
                  `items-center`
                )}
                onClick={() => toggleCategory(index)} // Toggle the category when the button is clicked
              >
                <span className={classnames(`pr-2.5`)}>
                  {isOpenMobile[index] ? (
                    <ArroweExpand className={arrowClassNames} />
                  ) : (
                    <ArrowCollapse className={arrowClassNames} />
                  )}
                </span>
                <div>
                  <h3 className={classnames(`text-theme-text`, `font-bold`, `leading-7`)}>
                    {item?.displayName}
                  </h3>
                </div>
              </button>
            </div>
            <div className={classnames(`pl-[30px]`, `pr-[20px]`)}>
              <div
                className={classnames({
                  ['my-[30px]']: isOpenMobile[index],
                  ['p-0']: !isOpenMobile[index],
                  ['hidden']: !isOpenMobile[index],
                })}
              >
                <PlaceholderWrapper
                  name={`nmdp-tabs-content-${String.fromCharCode(index + 97)}`}
                  rendering={rendering}
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
